import PageWrapper from 'components/PageWrapper'

import TransferActivityDetail from './components/TransferActivityDetail'

const TransferActivityDetailPage = () => (
  <PageWrapper title='Transferencia' viewSelected='/movimientos'>
    <section className='text-black md:flex md:max-w-564 md:flex-col md:mb-5 mx-auto'>
      <TransferActivityDetail />
    </section>
  </PageWrapper>
)

export default TransferActivityDetailPage
